<template>
  <section>
    <top-navbar :menu-opened.sync="menuOpened" />
    <app-menu :active.sync="menuOpened" :bottom="true" />
    <page-banner
      :image="$route.meta.image"
      :title="title"
      :icon="icon"
      :links="links"
    />
    <router-view :title.sync="title" :icon.sync="icon" />
  </section>
</template>

<script>
import TopNavbar from "@/components/Page/TopNavbar.vue";
import PageBanner from "@/components/Page/Banner";
import Menu from "@/components/Menu.vue";
export default {
  components: {
    TopNavbar,
    PageBanner,
    "app-menu": Menu,
  },

  computed: {
    links() {
      console.log(this);
      return [
        {
          title: this.title,
          to: { name: this.$route.name, params: this.$route.params },
        },
      ];
    },
  },

  data() {
    return {
      title: null,
      menuOpened: false,
      icon: null,
    };
  },

  watch: {
    "$route.meta.title": {
      immediate: true,
      handler(title) {
        this.title = title;
      },
    },
  },
};
</script>

<style>
</style>
